var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"openid-get"},[_c('vue-qr',{attrs:{"text":_vm.url,"margin":0,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }